import Vue from 'vue';
import Router from 'vue-router';

import home from '../home/home.vue';
import notFound from '../home/notFound.vue';
import Company from '../components/contentPage/Company.vue'
import Brand from '../components/contentPage/Brand.vue'
import Products from '../components/contentPage/Products.vue'
import ProductDetail from '../components/contentPage/ProductDetail.vue'
import History from '../components/contentPage/History.vue'
import News from '../components/contentPage/News.vue'
import Factory from '../components/contentPage/Factory.vue'


Vue.use(Router);


const routes = [
    {
        path: '/',
        name: 'home',
        component: home,
    },
    {
        path: '*',
        name: 'notfound',
        component: notFound,
    },
    {
        path: '/company',
        name: 'Company',
        component: Company,
        meta: {
            title: '公司介绍 - 太丰官网'
        }
    },
    {
        path: '/brand',
        name: 'Brand',
        component: Brand,
        meta: {
            title: '品牌介绍 - 太丰官网'
        }
    },
    {
        path: '/products',
        name: 'Products',
        component: Products,
        meta: {
            title: '产品类目 - 太丰官网'
        }
    },
    {
        path: '/factory',
        name: 'factory',
        component: Factory,
        meta: {
            title: '产品类目 - 太丰官网'
        }
    },
    {
        path: '/product/:id',
        name: 'ProductDetail',
        component: ProductDetail,
        meta: {
            title: '产品详情 - 太丰官网'
        }
    },
    {
        path: '/history',
        name: 'History',
        component: History,
        meta: {
            title: '发展历程 - 太丰官网'
        }
    },
    {
        path: '/news',
        name: 'News',
        component: News,
        meta: {
            title: '新闻资讯 - 太丰官网'
        }
    }
];

const router = new Router({
    mode: 'history',  // 启用 history 模式
    routes,
});

export default router;
/*const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth'
            }
        } else if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

// 全局路由守卫，设置页面标题
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

export default router*/
